import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "content-copy-save-outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-content-save-outline',
    templateUrl: './icon-content-save-outline.component.html',
    styleUrls: ['./icon-content-save-outline.component.scss'],
    standalone: false
})
export class IconContentSaveOutlineComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
